import { FC } from "react";
import { Box, Typography } from "@material-ui/core";
import { useStyles } from "./styles";
import { SparkChartTemp } from "componentsNew/charts/SparkTemp";

interface GraphStatsBoxProps {
  title: string;
  count: number | null;
  dataList: any[];
}

const GraphStatsBox: FC<GraphStatsBoxProps> = ({ title, count, dataList }) => {
  const classes = useStyles();

  return (
    <Box className={classes.graphStatsBox}>
      <Box className={classes.graphStatCounts}>
        <Typography className={classes.graphStatCount}>{count || 0}</Typography>
        <Typography className={classes.graphStatName}>{title}</Typography>
      </Box>
      <Box className={classes.graphGraphBox}>
        <SparkChartTemp
          data={dataList}
          height={66}
        />
      </Box>
    </Box>
  );
};

export default GraphStatsBox;
